// extracted by mini-css-extract-plugin
module.exports = {"placeholderWrap":"NoDataPlaceholder_placeholderWrap__zX5VM"};